module.exports = __webpack_public_path__ + "static/newsletter-f58f274b896c4d87356a3a939c648d17.jpg";